import React, { Component } from 'react';

class Footer extends Component {
  render () {
    return (
      <footer className="footer">
        <div className="container-fluid">
          <div className="d-sm-flex justify-content-sm-between">
            <span className="text-muted text-center text-sm-left d-block d-sm-inline-block">© 2021 <a href="http://softanis.com/" target="_blank" rel="noopener noreferrer">Softanis</a>. All rights reserved. <a href="https://www.bootstrapdash.com/demo/star-admin-pro-react/template/demo_1/preview/dashboard" target="_blank">Theme</a></span>
            {/* <span className="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted & made with <i className="mdi mdi-heart text-danger"></i></span> */}
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;